module.exports = __webpack_public_path__ + "img/kr.0423a24f.png";